import React, { ReactElement } from 'react';
import { Stack, Breadcrumbs, Typography, Link } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CustomSearchBar from "../SearchBar/CustomSearchBar";
import Styles from "./ActivityBar.module.css";

interface ActivityBarProps {
  breadcrumbs: ReactElement[]; // Define breadcrumbs as an array of React elements
}

const ActivityBar: React.FC<ActivityBarProps> = ({ breadcrumbs }) => {
  return (
    <div className={Styles.activityBar}>
      <Stack spacing={2}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          {breadcrumbs}
        </Breadcrumbs>
      </Stack>
      <CustomSearchBar />
    </div>
  );
};

export default ActivityBar;
